import type { FusionHubJobStatus } from "src/common/service/fusionHub/types.ts";

const IS_FINISHED: Record<FusionHubJobStatus, boolean> = {
	PREPARING: false,
	QUEUED: false,
	RESERVED: false,
	RUNNING: false,
	COMPLETED: true,
	FAILED: true,
	TRANSIENT_FAILURE: true,
};

export const isJobFinished = (status: FusionHubJobStatus): boolean =>
	IS_FINISHED[status];
